import { Algolia, Hits } from '@/infrastructure/network/Algolia/schema'
import { AlgoliaRequest } from '@/infrastructure/network/AlgoliaRequest'

export class FetchDoctor implements AlgoliaRequest<Algolia.Doctor.FetchDoctorResponse> {
  response: Algolia.Doctor.FetchDoctorResponse
  index: string
  items: string
  hits?: Hits
  word: string
  constructor(word?: string | null, hits?: Hits) {
    this.hits = hits
    this.word = word || ''
    this.index = `${process.env.SCOUT_PREFIX}doctors`
    this.items = 'doctors'
  }
}
